import React, { Component } from 'react'
import './ActivityDetail.css'
import {ActivityService} from '../../api/api'
import moment from 'moment'
import {FormattedMessage} from 'react-intl'
export default class ActivityDetail extends Component {
  state={
    model:{}
  }
  componentDidMount = () => {
    ActivityService.Detail(this.props.match.params.id).then(result=>{

      console.log(result);
      this.setState({
         model:result.DataResult
     });
    })
  }
  
  render() {
    let {model}=this.state;
    return (
     
      <div>
         <div className="activities_con activities_detail">
                <div className="indexDiv ">
                    <div className="center home_Acitivites">
                        <div className="titleH4">
                            <h4>{model.ActivityName}</h4>
                            <p>
                              <span className="margin_span"><FormattedMessage id="intl-Menu-Hours"/>:{moment(model.ActivityDate).format('YYYY.MM.DD')}</span>
                              |
                              <span className="margin_span"> <FormattedMessage id="upper-limit"/>:{model.SignUpPeopleNumberTop} people</span>
                              |
                              <span className="margin_span"> <FormattedMessage id="intl-location"/>:{model.ActivityVenue}</span>
                            </p>
                        </div>
                    </div>
                </div>
                
                <div className="activities_detail_con">
                      <h3><FormattedMessage id="intl-activityContent"/></h3>
                      <div dangerouslySetInnerHTML={{__html:model.ActivityContent}} className="activities_detail_con-dis"></div>
                      <h3><FormattedMessage id="intl-agenda"/></h3>
                      <div dangerouslySetInnerHTML={{__html:model.Scheduling}} className="activities_detail_con-dis"></div>
                      <h3><FormattedMessage id="intl-activityRule"/></h3>
                      <div dangerouslySetInnerHTML={{__html:model.ActivityRules}} className="activities_detail_con-dis"></div>
                      <div className="activities_detail_bottom">
                        
                        
                        <p>
                            <img src={"/images/mpqr.jpg"} width="160" alt="" />
                        </p>
                        <p>
                        
                        <FormattedMessage id="intl-qrTip"/>
                        <br/> <FormattedMessage id="intl-welcome"/>━(*｀∀´*)ノ亻!
                        
                        </p>
                      </div>
                </div>
         </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Activities/ActivityDetail.js